import { Dialog } from 'primereact/dialog'
import React, { useContext, useState } from 'react'
import { Button } from 'primereact/button'
import { useMountEffect } from 'primereact/hooks'
import { CommonContext } from '../common/context/commonContext'
import { LocationPasswordProps, LocationPasswordReq } from '../../types/inventory'
import { InputText } from 'primereact/inputtext'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const LocationChangeCheckDialog = (props: LocationPasswordProps) => {
    const { $toast, $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const [errorMsg, setErrorMsg] = useState<string>()

    useMountEffect(() => {
        if (!props.visible) return
        formik.validateField('password')
        setErrorMsg('')
    })
    const onHide = async (isCheck: boolean) => {
        props.onHide(isCheck)
        setErrorMsg('')
        formik.resetForm()
    }

    const initialValues: LocationPasswordReq = {
        password: '',
    }

    const formik = useFormik({
        initialValues,
        validationSchema: object({
            password: string().required('*공통 비밀번호는 필수입니다.'),
        }),
        onSubmit: async (data: LocationPasswordReq) => {
            // console.log('onSubmit', data)
            await $http()
                .post('/inventory/check-password', data)
                .then((result: any) => {
                    if (!result) return // null pass
                    if (result.isVaildPassword === false) {
                        setErrorMsg('*비밀번호가 일치하지 않습니다.')
                        return
                    }
                    if (result.succCd !== 'S') {
                        $toast({
                            title: t(tokens.common.fail),
                            icon: 'failure',
                        })
                        return
                    }

                    onHide(true)
                })
        },
    })

    const header = (title: string) => {
        return <div>{title}</div>
    }

    return (
        <Dialog
            header={header(t(tokens.inventory.edit_location_information))}
            visible={props.visible}
            onHide={() => onHide(false)}
            closable={false}
            contentClassName="pb-0"
        >
            <div className="grid">
                <div className="col-12 flex">{t(tokens.inventory.modify_selected_location_info)}</div>
                <div className="col-12 flex pt-3">
                    <label className="text-color-purple text-lg required font-bold">{t(tokens.common.pda_admin_password)}</label>
                </div>
                <div className="col-12 p-0 flex">
                    <InputText
                        id="password"
                        type="password"
                        className="p-inputtext w-full"
                        placeholder="Password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        autoComplete="one-time-code"
                    />
                </div>
                {formik.errors.password ? (
                    <span className="ml-1 mt-1 text-yellow-600" style={{ fontSize: '12px' }}>
                        {formik.errors.password}
                    </span>
                ) : null}
                <div className="col-12" style={{ minHeight: '26px' }}>
                    {errorMsg ? <span className="text-yellow-600 mt-1">{errorMsg}</span> : null}
                </div>
                <form onSubmit={formik.handleSubmit} className="w-full">
                    <div className="col-12 flex w-full align-items-center">
                        <div className="col-6">
                            <Button
                                className="w-full p-button-secondary"
                                label={t(tokens.common.cancel)}
                                size="large"
                                type="button"
                                onClick={() => onHide(false)}
                            />
                        </div>
                        <div className="col-6">
                            <Button className="w-full p-button-warning" label={t(tokens.common.edit)} size="large" type="submit" />
                        </div>
                    </div>
                </form>
            </div>
        </Dialog>
    )
}

export default LocationChangeCheckDialog
